import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PersonaModel } from "../../types/persona";

export interface PersonaState {
    loading: boolean;
    loadingError: string;
    // generalEntities: PersonaModel[];
    personas: PersonaModel[];
    generalAIEntity: PersonaModel;
}

const initialState: PersonaState = {
    loading: false,
    loadingError: "",
    personas: [],
    // generalEntities: [],
    generalAIEntity: {
        first_name: "General",
        last_name: "AI Entity",
        is_general_entity: "yes",
        description: "",
        specificities: ""
    }
};

const personaSlice = createSlice({
    name: "persona",
    initialState,
    reducers: {
        setPersonaLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setPersonaLoadingError: (state, action: PayloadAction<string>) => {
            state.loadingError = action.payload;
        },
        populatePersonas: (state, action: PayloadAction<PersonaModel[]>) => {
            // TODO: FETCH GENERAL AI ENTITY
            // const generalAiEntity = { ...action.payload[0] };
            // generalAiEntity.id = "ai_entity";
            // generalAiEntity.first_name = "General";
            // generalAiEntity.last_name = "AI Entity";
            // generalAiEntity.type = "entity";
            // set Generate entity
            // state.generalAIEntity = generalAiEntity;

            // Remove personas with empty names or the general entity
            const personas = action.payload.filter(
                (persona: PersonaModel) =>
                    (persona.first_name || persona.last_name) && persona.is_general_entity !== "yes"
            );

            // Populate General Entity if available
            const generalEntity = action.payload.find(
                (persona: PersonaModel) => persona.is_general_entity === "yes"
            );

            state.personas = [...personas];
            if (generalEntity) {
                state.generalAIEntity = generalEntity;
            }
        },
        addPersona: (state, action: PayloadAction<PersonaModel>) => {
            if (action.payload.is_general_entity === "yes") {
                state.generalAIEntity = action.payload;
            } else {
                state.personas.push(action.payload);
            }
        }
    }
});

export const selectPersona = (state: { persona: PersonaState }) => state.persona.personas;

// Export actions
export const { setPersonaLoading, setPersonaLoadingError, populatePersonas, addPersona } =
    personaSlice.actions;

export default personaSlice.reducer;
